import { CourseAbschluss } from './CourseAbschluss.js';
import { CourseChancenschule } from './CourseChancenschule.js';
import { CourseDigital } from './CourseDigital.js';
import { CourseIntensive } from './CourseIntensive.js';
import { CourseLernfoerderung } from './CourseLernfoerderung.js';
import { CourseLUS } from './CourseLUS.js';

export const COURSE_TITLES = {
  [CourseLernfoerderung._class]: 'Lernförderung',
  [CourseIntensive._class]: 'Intensivkurs (Präsenz)',
  [CourseDigital._class]: 'Intensivkurs (Digital)',
  [CourseChancenschule._class]: 'Chancenschule',
  [CourseAbschluss._class]: 'CHANCENabschluss',
  [CourseLUS._class]: 'Leseadler und Schreibfüchse',
};

export const COURSE_TITLES_SHORT = {
  [CourseLernfoerderung._class]: 'LF',
  [CourseIntensive._class]: 'IK',
  [CourseDigital._class]: 'DK',
  [CourseChancenschule._class]: 'SCH',
  [CourseAbschluss._class]: 'ABS',
  [CourseLUS._class]: 'LUS',
};
